//const BASE_URL = "http://192.168.1.239/vone_system"
//const BASE_URL = "http://192.168.1.254/oakya_dev/vone/api"
const BASE_URL  = "http://demo.jksoftech.in/api"

//live url

//const BASE_URL  = "https://v1.oakyaitservices.in/api"



// demo live url
//const BASE_URL  = "https://vonedev.oakyaitservice.com/api"


const API_URLS = {

getqrcodeimages:{
  url: `${BASE_URL}/qrcodes/`
},

getElecticianImages:{
  url: `${BASE_URL}/electrician/`
},


getDelearImages:{
  url: `${BASE_URL}/dealer/`
},

//gift schema images
getElecticianGiftImages:{
  url: `${BASE_URL}/electrician_gift_scheme/`
},

getDealerGiftImages:{
  url: `${BASE_URL}/dealer_gift_scheme/`
},


getDealerOrderImages:{
  url: `${BASE_URL}/dealer_orderdetails/`
},




//admin profile

adminLogin:{
  url: `${BASE_URL}/admin/login.php`,
  method: 'POST'
},

adminProfileretrieve:{
  url: `${BASE_URL}/admin/retrieve.php`,
  method: 'POST'
},

CreateEmployee:{
  url: `${BASE_URL}/admin/create.php`,
  method: 'POST'
},

UpdateEmployee:{
  url: `${BASE_URL}/admin/update.php`,
  method: 'PUT'
},

getAllEmployees:{
  url: `${BASE_URL}/admin/retrieve.php`,
  method: 'GET'
},

//admin electrician points 

CreateElectricianPoints:{
  url: `${BASE_URL}/admin_electrician_points/create.php`,
  method: 'POST'
},

getAdminElectricianPoints:{
  url: `${BASE_URL}/admin_electrician_points/retrieve.php`,
  method: 'GET'
},

getAllAdminTransaction:{
    url: `${BASE_URL}/admin_electrician_points/transaction.php`,
  method: 'GET'
},


//company api's
  createcompany: {
    url: `${BASE_URL}/company/create.php`,
    method: 'POST',
  },
  updatecompany: {
    url: `${BASE_URL}/company/update.php`,
    method: 'POST',
  },
  getAllcompanys: {
    url: `${BASE_URL}/company/admincompany.php`,
    method: 'GET',
  },
  getActivecompany: {
    url: `${BASE_URL}/company/retrieve.php`,
    method: 'GET',
  },




//group api's
creategroup: {
  url: `${BASE_URL}/group/create.php`,
  method: 'POST',
},
updategroup: {
  url: `${BASE_URL}/group/update.php`,
  method: 'POST',
},
getAllgroup: {
  url: `${BASE_URL}/group/admingroup.php`,
  method: 'GET',
},
getActivegroup: {
  url: `${BASE_URL}/group/retrieve.php`,
  method: 'GET',
},



//manager api's
createmanager: {
  url: `${BASE_URL}/manager/create.php`,
  method: 'POST',
},
updatemanager: {
  url: `${BASE_URL}/manager/update.php`,
  method: 'POST',
},
getAllmanager: {
  url: `${BASE_URL}/manager/adminmanager.php`,
  method: 'GET',
},




//representative api's

createrepresentative: {
  url: `${BASE_URL}/representative/create.php`,
  method: 'POST',
},
updaterepresentative: {
  url: `${BASE_URL}/representative/update.php`,
  method: 'POST',
},
getAllrepresentative: {
  url: `${BASE_URL}/representative/adminrepresentative.php`,
  method: 'GET',
},

getActiveRepresentative : {
  url: `${BASE_URL}/representative/retrieve.php`,
  method: 'GET', 
},



//dealer api's

createdealer: {
  url: `${BASE_URL}/dealer/create.php`,
  method: 'POST',
},



updatedealer: {
  url: `${BASE_URL}/dealer/update.php`,
  method: 'POST',
},

updatedealerPermissions: {
  url: `${BASE_URL}/dealer/permission.php`,
  method: 'POST',
},
AssignDealer:{
  url: `${BASE_URL}/dealer/updateActivation.php`,
  method: 'POST',
}
,

getAlldealer: {
  url: `${BASE_URL}/dealer/admindealer.php`,
  method: 'GET',
},

getActiveDelaer : {
  url: `${BASE_URL}/dealer/retrieve.php`,
  method: 'GET', 
},


getdelearById:{
  url: `${BASE_URL}/dealer/retrieve.php`,
  method: 'POST', 
},
//Electrician api's

createelectrician: {
  url: `${BASE_URL}/electrician/admincreate.php`,
  method: 'POST',
},

updateelectrician: {
  url: `${BASE_URL}/electrician/update.php`,
  method: 'POST',
},
getAllelectrician: {
  url: `${BASE_URL}/electrician/adminelectrician.php`,
  method: 'GET',
},

getElectricianById:{
  url: `${BASE_URL}/electrician/adminelectrician.php`,
  method: 'POST',
},



getTodayelectrician: {
  url: `${BASE_URL}/electrician/adminelectrician.php`,
  method: 'GET',
},






//SalesBoy api's

createsalesboy: {
  url: `${BASE_URL}/sales_boy/create.php`,
  method: 'POST',
},
updatesalesboy: {
  url: `${BASE_URL}/sales_boy/update.php`,
  method: 'POST',
},
getAllsalesboy: {
  url: `${BASE_URL}/sales_boy/adminsalesboy.php`,
  method: 'GET',
},


//district api's
createdistrict: {
  url: `${BASE_URL}/district/create.php`,
  method: 'POST',
},
updatedistrict: {
  url: `${BASE_URL}/district/update.php`,
  method: 'POST',
},
getAlldistrict: {
  url: `${BASE_URL}/district/admindistrict.php`,
  method: 'GET',
},

getActivedistrict: {
  url: `${BASE_URL}/district/retrieve.php`,
  method: 'PUT',
},


//states api's
createstate: {
  url: `${BASE_URL}/state/create.php`,
  method: 'POST',
},
updatestate: {
  url: `${BASE_URL}/state/update.php`,
  method: 'POST',
},
getActiveState: {
  url: `${BASE_URL}/state/retrieve.php`,
  method: 'GET',
},
getAllState: {
  url: `${BASE_URL}/state/adminstate.php`,
  method: 'GET',
},




//qrcodes api's

createqrcodes: {
  url: `${BASE_URL}/qrcodes/create1.php`,
  method: 'POST',
},

getAllqrcodes: {
  url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
  method: 'GET',
},

getdatefiltersqrcodes: {
  url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
  method: 'POST',
},

getLimitqrcodes: {
  url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
  method: 'PUT',
},




getfreshLimitqrcodes: {
  url: `${BASE_URL}/qrcodes/retrieve.php`,
  method: 'PUT',
},

getSearchedqrDetails: {
  url: `${BASE_URL}/qrcodes/retrieve.php`,
  method: 'POST',
},


getUsedqrcodesDateFilters: {
  url: `${BASE_URL}/electrician_used_qrcodes/retrieve.php`,
  method: 'POST',
},


getUsedqrcodesLimitValue: {
  url: `${BASE_URL}/electrician_used_qrcodes/retrieve.php`,
  method: 'PUT',
},


getqrusedcodes: {
  url: `${BASE_URL}/electrician_used_qrcodes/adminretrieve.php`,
  method: 'GET',
},



getLimitValueqrusedcodes: {
  url: `${BASE_URL}/electrician_used_qrcodes/adminretrieve.php`,
  method: 'PUT',
},


updateqrusedcodes: {
  url: `${BASE_URL}/qrcodes/update.php`,
  method: 'POST',
},



fetchqrisprintornot:{
  url: `${BASE_URL}/qrcodes/update.php`,
  method: 'GET',
},









//ledger api's
getelectricianLedgerById: {
  url: `${BASE_URL}/electrician_ledger/retrieve.php`,
  method: 'POST',
},

getdealerLedgerById: {
  url: `${BASE_URL}/dealer_ledger/retrieve.php`,
  method: 'POST',
},

getelectricianLedgerdatefilterById: {
  url: `${BASE_URL}/electrician_ledger/retrieve.php`,
  method: 'PUT',
},


getdealerLedgerdatefilterById: {
  url: `${BASE_URL}/dealer_ledger/retrieve.php`,
  method: 'PUT',
},











//transations api's
getelectricianTransactionsById: {
  url: `${BASE_URL}/electrician_transaction/retrieve.php`,
  method: 'POST',
},

//reeedem gifts
getelectricianreedemgiftsById: {
  url: `${BASE_URL}/electrician_redeem_gift/retrieve.php`,
  method: 'POST',
},


getdealerreedemgiftsById: {
  url: `${BASE_URL}/dealer_redeem_gift/retrieve.php`,
  method: 'POST',
},














electricianLimitValue: {
  url: `${BASE_URL}/electrician/adminelectrician.php`,
  method: 'PUT',
},

electricianDateTimeValue: {
  url: `${BASE_URL}/electrician/adminelectrician.php`,
  method: 'PUT',
},
//gift card
createGiftCard: {
  url: `${BASE_URL}/electrician_gift_scheme/create.php`,
  method: 'POST',
},
updateGiftCard: {
  url: `${BASE_URL}/electrician_gift_scheme/update.php`,
  method: 'POST',
},
getGiftCard: {
  url: `${BASE_URL}/electrician_gift_scheme/adminretrieve.php`,
  method: 'GET',
},





createDealerGiftCard: {
  url: `${BASE_URL}/dealer_gift_scheme/create.php`,
  method: 'POST',
},

updateDealerGiftCard: {
  url: `${BASE_URL}/dealer_gift_scheme/update.php`,
  method: 'POST',
},
getDealerGiftCard: {
  url: `${BASE_URL}/dealer_gift_scheme/adminretrieve.php`,
  method: 'GET',
},









//Electrician Redeem card

getAllreedemgifts: {
  url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
  method: 'GET',
},

updatereedemgifts: {
  url: `${BASE_URL}/electrician_redeem_gift/update.php`,
  method: 'POST',
},  


getAllLIMITVALUEreedemgifts: {
  url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
  method: 'PUT',
},

getAllDATETIMEFILTERreedemgifts: {
  url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
  method: 'POST',
},



getelectriciangiftdispatch: {
  url: `${BASE_URL}/electrician_gift_dispatch/retrieve.php`,
  method: 'POST',
},


//dealer reedem  gifts


getAllDealerreedemgifts: {
  url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
  method: 'GET',
},

updateDealerreedemgifts: {
  url: `${BASE_URL}/dealer_redeem_gift/update.php`,
  method: 'POST',
},  


getAllLIMITVALUEDealerreedemgifts: {
  url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
  method: 'PUT',
},

getAllDATETIMEFILTERDealerreedemgifts: {
  url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
  method: 'POST',
},



getdealergiftdispatch: {
  url: `${BASE_URL}/dealer_gift_dispatch/retrieve.php`,
  method: 'POST',
},
















//counts

getelectriciancounts: {
  url: `${BASE_URL}/dashboard/count.php`,
  method: 'POST',
},


getPeronsDashboardcounts: {
  url: `${BASE_URL}/dashboard/count.php`,
  method: 'GET',
},

getdealercounts: {
  url: `${BASE_URL}/dashboard/dealer_count.php`,
  method: 'POST',
},



//Roles And Resposbilitys
createrolesandresponsibilities: {
  url: `${BASE_URL}/roles_responsibilities/create.php`,
  method: 'POST',
},

updaterolesandresponsibilities: {
  url: `${BASE_URL}/roles_responsibilities/update.php`,
  method: 'POST',
},

fetchrolesandresponsibilitys: {
  url: `${BASE_URL}/roles_responsibilities/retrieve.php`,
  method: 'POST',
},

// screens
getscreennames: {
  url: `${BASE_URL}/screen/retrieve.php`,
  method: 'GET',
},


//categorys


getcategorynames: {
  url: `${BASE_URL}/dealer_products/category.php`,
  method: 'POST',
},

getproductslist: {
  url: `${BASE_URL}/dealer_products/retrieve.php`,
  method: 'PUT',
},

updateproductlist: {
  url: `${BASE_URL}/dealer_products/update.php`,
  method: 'POST',
},



//orders
getorderslist: {
  url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
  method: 'GET',
},
getorderDetails: {
  url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
  method: 'PUT',
},



getDealerorderHistory: {
  url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
  method: 'POST',
},

getDealerorderHistoryById: {
  url: `${BASE_URL}/dealer_orderdetails/adminretrieve.php`,
  method: 'POST',
},


getDealerorderDetailsRecentHistory: {
  url: `${BASE_URL}/dealer_orderdetails/recent.php`,
  method: 'PUT',
},


updateOrderStatus: {
  url: `${BASE_URL}/dealer_orderdetails/update.php`,
  method: 'POST',
},









updateHoldStatus: {
  url: `${BASE_URL}/dealer_redeem_gift/hold_update.php`,
  method: 'POST',
},



electricianupdateHoldStatus: {
  url: `${BASE_URL}/electrician_redeem_gift/hold_update.php`,
  method: 'POST',
},






updateGiftImage: {
  url: `${BASE_URL}/dealer_redeem_gift/update.php`,
  method: 'POST',
},





};
export default API_URLS;
